<template>
  <el-col :span="24" class="keep">
    <div class="shop-list">
      <a href="/MerchantList" style="text-decoration:none; color:#333;" ><tit class="title">商家列表</tit></a>
      <el-row :gutter="10"  class="piclist" >
        <el-col :span="1" :xs="12" :sm="12" :md="8"  :lg="6"><div class="picbox"><a href="/Merchant/LululemonCA"><img width="100%" height="100%" class="bg" src="https://pic.joyorders.com/banner/h-1.png" /></a></div></el-col>
        <el-col :span="1" :xs="12" :sm="12" :md="8"  :lg="6"><div class="picbox"><a href="/Merchant/bashus"><img width="100%" height="100%" class="bg" src="https://pic.joyorders.com/banner/h-2.png"/></a></div></el-col>
        <el-col :span="1" :xs="12" :sm="12" :md="8"  :lg="6"><div class="picbox"><a href="/Merchant/Macys/"><img width="100%" height="100%" class="bg" src="https://pic.joyorders.com/banner/h-3.png"/></a></div></el-col>
        <el-col :span="1" :xs="12" :sm="12" :md="8"  :lg="6"><div class="picbox"><a href="/Merchant/Bloomingdales"><img width="100%" height="100%" class="bg" src="https://pic.joyorders.com/banner/h-4.png"/></a></div></el-col>
        <el-col :span="1" :xs="12" :sm="12" :md="8"  :lg="6"><div class="picbox"><a href="/Merchant/BergdorfGoodman"><img width="100%" height="100%" class="bg" src="https://pic.joyorders.com/banner/h-5.png"/></a></div></el-col>
        <el-col :span="1" :xs="12" :sm="12" :md="8"  :lg="6"><div class="picbox"><a href="/Merchant/SephoraUS"><img width="100%" height="100%" class="bg" src="https://pic.joyorders.com/banner/h-6.png"/></a></div></el-col>
        <el-col :span="1" :xs="12" :sm="12" :md="8"  :lg="6"><div class="picbox"><a href="/Merchant/coach"><img width="100%" height="100%" class="bg" src="https://pic.joyorders.com/banner/h-7.png"/></a></div></el-col>
          <el-col :span="1" :xs="12" :sm="12" :md="8"  :lg="6"><div class="picbox"><a href="/Merchant/Lacoste" ><img width="100%" height="100%" class="bg" src="https://pic.joyorders.com/banner/h-8.png"/></a></div></el-col>
        <!--<el-col :span="1" :xs="12" :sm="12" :md="8"  :lg="6"><div class="picbox"><a href="/Merchant/ConverseUS"><img width="100%" height="100%" class="bg" src="https://pic.joyorders.com/banner/h-1.png" /></a></div></el-col>
        <el-col :span="1" :xs="12" :sm="12" :md="8"  :lg="6"><div class="picbox"><a href="/items/45?page=1/"><img width="100%" height="100%" class="bg" src="https://pic.joyorders.com/banner/h-2.png"/></a></div></el-col>
        <el-col :span="1" :xs="12" :sm="12" :md="8"  :lg="6"><div class="picbox"><a href="/Merchant/Macys/"><img width="100%" height="100%" class="bg" src="https://pic.joyorders.com/banner/h-3.png"/></a></div></el-col>
        <el-col :span="1" :xs="12" :sm="12" :md="8"  :lg="6"><div class="picbox"><a href="/Merchant/Bloomingdales"><img width="100%" height="100%" class="bg" src="https://pic.joyorders.com/banner/h-4.png"/></a></div></el-col>
        <el-col :span="1" :xs="12" :sm="12" :md="8"  :lg="6"><div class="picbox"><a href="/Merchant/BergdorfGoodman"><img width="100%" height="100%" class="bg" src="https://pic.joyorders.com/banner/h-5.png"/></a></div></el-col>
        <el-col :span="1" :xs="12" :sm="12" :md="8"  :lg="6"><div class="picbox"><a href="/Merchant/Barneys"><img width="100%" height="100%" class="bg" src="https://pic.joyorders.com/banner/h-6.png"/></a></div></el-col>
        <el-col :span="1" :xs="12" :sm="12" :md="8"  :lg="6"><div class="picbox"><a href="/Merchant/coach"><img width="100%" height="100%" class="bg" src="https://pic.joyorders.com/banner/h-7.png"/></a></div></el-col>
          <el-col :span="1" :xs="12" :sm="12" :md="8"  :lg="6"><div class="picbox"><a href="/Merchant/Lacoste" ><img width="100%" height="100%" class="bg" src="https://pic.joyorders.com/banner/h-8.png"/></a></div></el-col>-->
        </el-row>

      <!--<div class="shop-l">-->
        <!--<div v-for="pics in picurl" class="picbox">-->
          <!--<a :href="pics.url">-->
            <!--<img :src="pics.url" alt="">-->
          <!--</a>-->
        <!--</div>-->
      <!--</div>-->

    </div>
  </el-col>
</template>

<script>
import tit from './Title'
import api from '../../services/api.js'
// import {FILE_HOST} from '../../services/constant.js'
let $ = require('jQuery')
let _ = require('lodash')

export default {
  name: 'ShopList',
  components: {
    tit: tit
  },
  created: function () {
    this.getBusinessList()
  },
  data () {
    return {
      picurl: [
        {
          url: '../../assets/images/banner/h-1.png',
          pic: '/Merchant/4247'
        }, {
          url: '../../assets/images/banner/h-1.png',
          pic: '/items/45?page=1'
        }, {
          url: '../../assets/images/banner/h-1.png',
          pic: '/Merchant/81/'
        }, {
          url: '../../assets/images/banner/h-1.png',
          pic: '/Merchant/549'
        }, {
          url: '../../assets/images/banner/h-1.png',
          pic: '/Merchant/503'
        }, {
          url: '../../assets/images/banner/h-1.png',
          pic: '/Merchant/50'
        }, {
          url: '../../assets/images/banner/h-1.png',
          pic: '/Merchant/4239'
        }, {
          url: '../../assets/images/banner/h-1.png',
          pic: '/Merchant/79'
        }
      ],
      search: '',
      brandHeight: '300px',
      list: [],
      pages: 1,
      //      FILE_HOST: FILE_HOST,
      srcurl: ['../../assets/images/brand/(1).png']

    }
  },
  methods: {
    calShopListHeight: function () {
      $(document).ready(() => {
        this.brandHeight = $('.brand-list').height() - 10 + 'px'
        $(window).resize(() => {
          this.brandHeight = $('.brand-list').height() - 10 + 'px'
        })
      })
    },
    async getBusinessList () {
      let { body } = await api.getBusinessList(this)
      this.list = _.chunk(body.result || [], 8)
      this.calShopListHeight()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  .shop-list {
    /*max-width: 1320px;*/
    margin: 60px auto 0;
    max-width: 1240px;
    @media screen and (max-width: 768px) {
      margin: 8px;
    }
    .brand-list-container {
      margin-top: 70px;

      .brand {
        margin-bottom: 10px;
        img {
          vertical-align: middle;
          width: 100%;
        }
      }
    }
    .piclist{
      @media screen and (max-width: 1023px) {
        /*margin: 8px;*/
        width: 66%;
        margin-left: 17% !important;
      }
      @media screen and (max-width: 768px) {
        /*margin: 8px;*/
        width: 100%;
        margin: 0 auto !important;
      }
      .picbox{
        width: 300px;
        height: 192px;
        margin: 8px auto;
        @media screen and (max-width: 768px) {
          width: 100%;
          height: 100%;
          margin: 4px auto;
        }
      }

    }

  }

</style>



// WEBPACK FOOTER //
// src/pages/home/ShopList.vue